export const harvestQueryKeys = {
  land: ['land'],
  harvestRegionStats: ['harvest-region-stats'],
  harvestFarmerStats: ['harvest-farmer-stats'],
  harvestContractStats: ['harvest-contract-stats'],
  harvestGrainCount: ['harvest-grain-count'],
  harvestGrainContractTotals: ['harvest-grain-contract-totals'],
  harvestGrainSignedPk10ByRegion: ['harvest-grain-signed-pk10-by-region'],
  harvestPlacesRegionStats: ['harvest-places-region-stats'],
  harvestPlace: ['harvest-place'],
};
